import { AgentumReportWithRelations } from '@api/generated'
import { useParams } from 'react-router-dom'
import { apiCall } from '@api/resources/apiCall'
import { PROJECT } from '@modules/missions/keaz/const'
import { BaseReportFields, ReportSubtype, ReportType } from '@modules/missions/keaz/types'
import { skipToken } from '@reduxjs/toolkit/query'
import maxBy from 'lodash/maxBy'
import { formatDate } from '@modules/missions/keaz/utils/date'

interface TasksTableCellClosingDateProps {
  task: AgentumReportWithRelations
}

export function TasksTableCellClosingDate({ task }: TasksTableCellClosingDateProps) {
  const { missionId } = useParams()
  const { data: steps = [] } = apiCall.useAgentumReportControllerFindQuery(
    missionId
      ? [
          missionId,
          PROJECT,
          {
            where: {
              [BaseReportFields.subtype]: ReportSubtype.step,
              [BaseReportFields.taskId]: task[BaseReportFields.origin],
              [BaseReportFields.deleted]: false
            }
          }
        ]
      : skipToken
  )

  const hasUnsignedSteps = steps.some((step) => step[BaseReportFields.type] === ReportType.unsigned)
  const maxTimestampEndStep = maxBy(steps, BaseReportFields.timestampEnd)

  if (hasUnsignedSteps || !maxTimestampEndStep) {
    return <></>
  }

  return <>{formatDate(maxTimestampEndStep[BaseReportFields.timestampEnd] as number)}</>
}
